import type { CSSProperties } from 'react'

import type { BlueprintPaddingModifier } from '@/grove-blueprints/generated-types'

export function resolvePaddingModifier(
  modifier: BlueprintPaddingModifier,
): CSSProperties {
  const style: CSSProperties = {}

  const { top, bottom, leading, trailing } = modifier.values

  if (top !== undefined) {
    style.paddingTop = `${top}px`
  }

  if (bottom !== undefined) {
    style.paddingBottom = `${bottom}px`
  }

  if (leading !== undefined) {
    style.paddingInlineStart = `${leading}px`
  }

  if (trailing !== undefined) {
    style.paddingInlineEnd = `${trailing}px`
  }

  return style
}
